import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../../../../../common/Button';
import Grammar from './Grammar';

function CorrectAnswer(props) {
  const answeringQuestions = useSelector(state => state.answeringQuestions);
  const isCorrectAnswer = useSelector(state => state.questionView).isCorrectAnswer;

  return (
    <div 
      // style={{zIndex: 99999}}
      className="btn-viewopen-wrap"
    >
      <Button
        style={{width: 80}}
        className={clsx('btn-viewopen', 'on')}
        onClick={props.onCorrectAnswer}
      >
        정답보기
      </Button>
      {
        isCorrectAnswer && (
          <Grammar answer={answeringQuestions?.data?.qstCransr} />
        )
      }
    </div>
  );
}

export default CorrectAnswer;